export default {
  updatePhysicianData({ commit, state }, physicianData) {
    commit('setPhysicianSignUpData', { ...state.data, physicianData })
  },
  updateClinicData({ commit, state }, clinicData) {
    commit('setPhysicianSignUpData', { ...state.data, clinicData })
  },
  updateTrackingData({ commit, state }, trackingData) {
    commit('setPhysicianSignUpData', {
      ...state.data,
      trackingData: { ...(state.trackingData ?? {}), ...trackingData },
    })
  },
  clearData({ commit }) {
    commit('setPhysicianSignUpData', {})
  },
}
